import { render, staticRenderFns } from "./MedicationFormTable.vue?vue&type=template&id=bd540892&scoped=true"
import script from "./MedicationFormTable.vue?vue&type=script&lang=js"
export * from "./MedicationFormTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd540892",
  null
  
)

export default component.exports